import { setValue } from "../../lib/immutable_wrapper";
import { SET_COMPANIES } from "./companiesConstants";

const initialState = {
    companies: [],
};

export function companies(state = initialState, action) {
    switch (action.type) {
        case SET_COMPANIES:
            return setValue(state, ["companies"], action.companies);
        default:
            return state;
    }
}
